export enum SignupTrackEventName {
  FieldCompleted = 'Signup Field Completed',
  Submitted = 'Signup Submitted',
  Failed = 'Signup Failed',
  Started = 'Signup Started',
  TermsAccepted = 'Signup Terms Accepted',
}

export type SignupEntryPoint =
  | 'login_screen'
  | 'login_modal'
  | 'guest_prompt'
  | 'nav_bar'
  | 'oauth_flow'
  | 'checkout_flow';

export type SignupMethod = 'native' | 'oauth_google' | 'oauth_facebook' | 'oauth_apple';
